import { groupBy } from 'lodash';
import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as TaskTemplateIcon } from 'assets/svgs/save-task-template.svg';
import {
  CustomDueDatePicker,
  DateValue,
} from 'components/atoms/due-date-picker';
import { TaskTemplateLight } from 'data/templates/tasks';
import {
  BoldTextWrapper,
  DatePicker,
  DatePickerWrapper,
  DrawerSectionHeader,
  RoadMap,
  ScrollableView,
  ShowSavedTemplates,
  TaskDatePanel,
  TaskTemplateNameWithDate,
  TemplateEllipsis,
  TemplateNameHeader,
  TemplateSection,
} from '../styles';

interface DrawerSecondPhaseProps {
  selectedTemplates: TaskTemplateLight[];
  initialPhaseDates: (DateValue | undefined)[];
  onDatePickerChange: (
    values: [DateValue, DateValue],
    taskTemplate: TaskTemplateLight,
  ) => void;
}

export const DrawerSecondPhase: FC<DrawerSecondPhaseProps> = ({
  selectedTemplates,
  onDatePickerChange,
  initialPhaseDates,
}) => {
  const checkPhaseExtension = (
    template: TaskTemplateLight,
    phaseDates: (DateValue | undefined)[],
  ) => {
    return !!(
      moment(template.startDate).isBefore(moment(phaseDates[0])) ||
      moment(template.endDate).isAfter(moment(phaseDates[1]))
    );
  };

  return (
    <>
      <DrawerSectionHeader>
        <TaskDatePanel>
          <BoldTextWrapper>
            <FormattedMessage id="task" />
          </BoldTextWrapper>
          <BoldTextWrapper>
            <FormattedMessage id="projects.phase.import.start_date" />
          </BoldTextWrapper>
        </TaskDatePanel>
      </DrawerSectionHeader>

      <ScrollableView>
        {Object.values(groupBy(selectedTemplates, 'parentId')).map(
          (taskTemplateGroups) => {
            return (
              <TemplateSection key={taskTemplateGroups[0].parentId}>
                <TemplateNameHeader>
                  <ShowSavedTemplates>
                    <RoadMap />
                    <TemplateEllipsis>
                      {taskTemplateGroups[0].parentName}
                    </TemplateEllipsis>
                  </ShowSavedTemplates>
                </TemplateNameHeader>

                {taskTemplateGroups.map((taskTemplate) => {
                  const isPhaseExtended = checkPhaseExtension(
                    taskTemplate,
                    initialPhaseDates,
                  );

                  return (
                    <DatePickerWrapper key={taskTemplate.templateId}>
                      <ShowSavedTemplates>
                        <TaskTemplateIcon />
                        <TaskTemplateNameWithDate>
                          {taskTemplate.templateName}
                        </TaskTemplateNameWithDate>
                      </ShowSavedTemplates>
                      <DatePicker highlight={isPhaseExtended}>
                        <CustomDueDatePicker
                          block
                          key={taskTemplate.templateId}
                          startDate={taskTemplate.startDate}
                          dueDate={taskTemplate.endDate}
                          useAsStartDatePicker
                          onDateChange={(values: [DateValue, DateValue]) =>
                            onDatePickerChange(values, taskTemplate)
                          }
                        />
                      </DatePicker>
                    </DatePickerWrapper>
                  );
                })}
              </TemplateSection>
            );
          },
        )}
      </ScrollableView>
    </>
  );
};
